{
  "formGeneralDescription": "Mit diesem Formular können Sie Ihren PKI-Konnektor konfigurieren. Derzeit wird von LX CONNECT nur Microsoft PKI unterstützt.",
  "formRootCaDescription": "Die RootCA-Zertifizierungsstelle muss im .PEM-Format vorliegen und darf 1 MB nicht überschreiten.",
  "validation": {
    "url": "Die URL des PKI-Servers ist obligatorisch.",
    "urlFormat": "Ungültiges URL-Format",
    "login": "Die PKI-Server-Zugangskennung ist obligatorisch.",
    "password": "Das Passwort des PKI-Servers ist obligatorisch.",
    "templateName": "Der Name ist obligatorisch.",
    "templateFormat": "Ungültiger Vorlagenname",
    "pemFileSize": "Die .PEM-Datei darf 1 MB nicht überschreiten.",
    "pemFileMandatory": "Die Datei muss eine .PEM-Datei sein.",
    "rootCa": "RootCA ist obligatorisch",
    "pemFileEmpty": "Die .PEM-Datei darf nicht leer sein.",
    "pemFileInvalid": "Die .PEM-Datei ist ungültig."
  },
  "testConnection": {
    "messageSuccess": "Die PKI-Server-Parametrierung ist gültig.",
    "messageFailTitle": "Verbindungstest fehlgeschlagen",
    "messageFailConnectivity": "Ungültige URL",
    "messageFailAuthentication": "Ungültige Kombination aus Benutzername und Passwort",
    "messageFailRootca": "Ungültige RootCA",
    "tooltip": "Verbindung testen",
    "ok": "OK",
    "ko": "KO"
  },
  "button": {
    "viewCertificate": "Zertifikate anzeigen"
  },
  "filters": {
    "searchByAlias": "Nach Alias suchen"
  },
  "noPki": "Keine PKI gefunden",
  "alias": "Alias",
  "type": {
    "label": "Typ",
    "EST": "EST",
    "MICROSOFT": "Microsoft"
  },
  "url": "URL",
  "delete": {
    "title": "PKI-Verbindung löschen",
    "message": "Bestätigen Sie das Löschen dieser PKI-Verbindung? Mit dieser PKI wird keine Operation mehr möglich sein."
  },
  "form": {
    "title": {
      "create": "Eine neue Verbindung erstellen",
      "update": "Verbindungsedition"
    },
    "warning": {
      "title": "PKI-Zertifikat erforderlich",
      "message": "Ein dediziertes PKI-Zertifikat mit entsprechenden PKI-Tags muss im Schlüsselspeicher vorhanden sein."
    },
    "connectionSettings": {
      "title": "Verbindungseinstellungen"
    },
    "login": {
      "label": "Benutzername"
    },
    "password": {
      "label": "Passwort"
    },
    "specificConfiguration": {
      "templateName": {
        "label": "Vorlagenname"
      },
      "retryAfter": {
        "label": "Wiederholungsintervall"
      },
      "label": {
        "urlLabel": "Kennzeichnung"
      }
    },
    "validate": {
      "create": "Eine Verbindung hinzufügen",
      "update": "Speichern"
    },
    "cancel": {
      "confirm": {
        "title": {
          "create": "PKI-Verbindung erstellen",
          "update": "Aktualisierung der PKI-Verbindung"
        },
        "message": {
          "create": "Möchten Sie alle eingegebenen Informationen verwerfen und die Erstellung der PKI-Verbindung abbrechen? Alle Informationen gehen dann verloren.",
          "update": "Möchten Sie alle eingegebenen Informationen verwerfen und die Aktualisierung der PKI-Verbindung abbrechen? Alle Informationen gehen dann verloren."
        }
      }
    },
    "validation": {
      "alias": {
        "required": "Alias ist erforderlich",
        "max": "Alias darf maximal 50 Zeichen lang sein"
      },
      "url": {
        "required": "URL ist erforderlich",
        "max": "URL darf maximal 120 Zeichen lang sein"
      },
      "type": {
        "required": "Typ ist erforderlich"
      },
      "login": {
        "required": "Benutzername ist erforderlich"
      },
      "password": {
        "required": "Passwort ist erforderlich"
      },
      "templateName": {
        "required": "Vorlagenname ist erforderlich"
      },
      "intervalTime": {
        "required": "Wiederholungsintervall ist erforderlich",
        "min": "Der Wert darf nicht kleiner als 60 sein."
      },
      "urlLabel": {
        "max": "Kennzeichnung darf maximal 100 Zeichen lang sein",
        "format": "Die Kennzeichnung darf nur alphanumerische Zeichen, Bindestriche und Unterstriche enthalten."
      }
    },
    "trustChainsAliases": {
      "label": "Zugehöriges Zertifikat",
      "selectAll": "Alle Zertifikate auswählen",
      "selectSearchPlaceholder": "Nach Alias suchen",
      "selectNoResult": "Keine Zertifikate gefunden",
      "help": "Die PKI wird als Proxy verwendet, um die Zertifikate von Geräten, die durch das Truststore-Zertifikat identifiziert werden, zu erneuern, während gleichzeitig die Erneuerung der Keystore-Zertifikate durchgeführt wird."
    },
    "testConnection": {
      "button": "Verbindung testen",
      "noPassword": "Geben Sie ein Passwort ein, um die Verbindung zu testen."
    }
  }
}
